var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchNoresults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#142573",
    d: "M48.462 62.77c6.896 0 11.076-5.502 11.076-14.299v-.038c0-8.797-4.18-14.28-11.076-14.28-6.916 0-11.077 5.483-11.077 14.28v.038c0 8.798 4.16 14.298 11.077 14.298Zm0-4.045c-3.81 0-5.998-3.872-5.998-10.254v-.038c0-6.383 2.188-10.216 5.998-10.216 3.79 0 5.997 3.833 5.997 10.216v.038c0 6.383-2.207 10.254-5.997 10.254Z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#246BFF",
    d: "m68.4 72.316 3.916-3.916 6.853 6.853-3.916 3.916z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1452FF",
    d: "m73.295 79.822 6.527-6.527 25.456 25.456a4.614 4.614 0 0 1 0 6.527 4.614 4.614 0 0 1-6.527 0L73.295 79.822Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1452FF",
    fillRule: "evenodd",
    d: "M72.969 72.969c13.518-13.518 13.518-35.436 0-48.954s-35.436-13.518-48.954 0-13.518 35.436 0 48.954 35.436 13.518 48.954 0Zm-3.59-3.59c11.535-11.536 11.535-30.238 0-41.774-11.536-11.535-30.238-11.535-41.774 0-11.535 11.536-11.535 30.238 0 41.774 11.536 11.535 30.238 11.535 41.774 0Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#e)",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48.492,
    cy: 48.492,
    r: 29.538,
    fill: "#D5DFE8",
    transform: "rotate(-45 48.492 48.492)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 47.187,
    cy: 47.187,
    r: 27.692,
    fill: "#F5F7FB",
    opacity: 0.48,
    transform: "rotate(-45 47.187 47.187)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 12.708,
    height: 12.708,
    x: 66.461,
    y: 68.4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.938,
    dy: 1.938
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.969
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0980392 0 0 0 0 0.321569 0 0 0 0 0.517647 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_623_76"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 34.627,
    height: 35.273,
    x: 73.295,
    y: 71.357,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.292,
    dy: -3.231
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.969
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0980392 0 0 0 0 0.321569 0 0 0 0 0.517647 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_623_76"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 69.231,
    height: 69.231,
    x: 13.877,
    y: 13.877,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.323
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0980392 0 0 0 0 0.321569 0 0 0 0 0.517647 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_623_76"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 61.661,
    height: 61.661,
    x: 17.661,
    y: 17.661,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_623_76",
    stdDeviation: 0.646
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNoresults);
export default __webpack_public_path__ + "static/media/search-noresults.e1fe82574de4965ab0ef29552f4613d6.svg";
export { ForwardRef as ReactComponent };